import { type FileItem } from '../../models/files';
import { getUploadState } from '../files';

export function getUploadProgress(fileItem: FileItem): number {
  const upload = getUploadState(fileItem);

  if (!upload || upload.uploadStage === 'ERROR') {
    return 0;
  }

  let progress = 5; // base when upload has already started to make the progress visible

  // Sum of upload and encoding process (sums to 200)
  const uploadAndEncodingProgress = (upload.uploadProgress || 0) + (upload.encodingProgress || 0);

  // the upload and encoding progress should take up to 90% of the total progress
  const ratioToTotalProgress = 90 / 200;
  progress += uploadAndEncodingProgress * ratioToTotalProgress;

  // 5% for finalization of the encoding
  if (upload.uploadStage === 'ENCODED') {
    progress += 5;
  }

  if (progress > 100) {
    // make sure rounding errors won't make the progress exceed 100%
    progress = 100;
  }

  return progress;
}
